import {Table} from "antd";
import {toTimeString} from "../../util/timeutils";
import {fixedToDisplayUnit} from "../../util/unitutils";

export const ReturnTable = ({returns, props}) => {
    const columns = [
        {
            title: 'Invoice',
            dataIndex: 'invoiceNumber',
            key: 'invoiceNumber'
        },
        {
            title: 'Processed by',
            dataIndex: 'username',
            key: 'username'
        },
        {
            title: 'Date',
            dataIndex: 'timestamp',
            key: 'Date',
            render: (val, record, index) => {
                return toTimeString(new Date(val));
            }
        },
        {
            title: 'Item',
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            key: 'quantity',
            render: (val, record) => {
                const displayQuantity = fixedToDisplayUnit(val, record.unit);
                return displayQuantity;
            }
        },
        {
            title: 'Amount',
            dataIndex: 'refundAmount',
            key: 'refundAmount',
            render: (val) => `$ ${val}`
        }
    ]

    return <Table columns={columns} dataSource={returns} pagination={false} />
}